<div *ngIf="treeData" class="treeTop" style="font-size:.8rem">
  <div appCatDropper (catDrop)="droppedCat($event, node.id)" class="nodes" *ngFor="let node of treeData" [ngStyle]="{order: node.sortOrder}">
    <div class="d-flex align-items-center">
      <div class="nodeExpander curse" *ngIf="node.showChildren" (click)="toggleChild(node)"><b>-</b></div>
      <div class="nodeExpander curse" *ngIf="!node.showChildren && node.children.length != 0" (click)="toggleChild(node)"><b>+</b></div>
      <div class="nodeExpander" *ngIf="node.children.length == 0"><b> </b></div>
      <div class="nodeData btn" [ngClass]="node.originalData.isActive == false ? 'btn-danger' : node.originalData.isHidden == false ? 'btn-secondary' : 'btn-warning'" style="height:unset!important">
        <div class="nodeName curse d-flex justify-content-between align-items-center" (click)="shout({'question':'getCategory','answer':node.id})" draggable="true" id="{{node.id}}" (dragstart)="itsADrag($event, node.id)">
          <div class="d-flex align-items-center">
            <img style="width:50px;height:50px;object-fit:contain;padding-right:.5rem;" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ node.image }}" alt="" />
            <div>{{ node.name }}</div>
          </div>
          <div class="nodePackages ml-3">{{ node.numberOfPackages }} {{ 'Settings.Packages' | translate}}</div>
        </div>
      </div>
    </div>
    <div class="nodeChildren">
      <app-category-tree *ngIf="node.showChildren" [treeData]="node.children" (shout)="shout($event)"></app-category-tree>
    </div>
  </div>
</div>
